var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "cc26dadddc17f6560c215037801d4f26d8eb29a7"
};